/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification/src/modules/product-specification/./product-specification';
import { buildProductBadgeUrl } from '../utilities/productListExtensionHelpers';
import { canUseDOM } from '../utilities/helpers';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const attributesToIgnore = ['See Price In Cart', 'Product Badge Status'];
interface IProductSpecificationData extends IProductSpecificationViewProps {
    product?: SimpleProduct;
}
const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;
    const [attributeElementsToRender, setAttributeElementsToRender] = React.useState<JSX.Element[]>([]);
    const [badgeImageAdded, setBadgeImageAdded] = React.useState<boolean>(false);
    const elementsArray: JSX.Element[] = [];
    React.useEffect(() => {
        iterateAttributes();
    }, [productSpecificationResult]);

    const renderProductBadge = (badgeStatus: string) => {
        const badgeUrl = buildProductBadgeUrl(props.context.request.locale, badgeStatus, props.context.request.apiSettings.baseImageUrl, '_PDP');
        const mainImage = document.querySelectorAll('.msc-carousel__inner');
        if (mainImage.length && mainImage.length > 1) {
            const badgeImage = document.createElement('img');
            badgeImage.src = badgeUrl;
            badgeImage.classList.add('msc-product__badge');
            badgeImage.classList.add('msc-product__badge--detail');
            badgeImage.alt = badgeStatus;
            mainImage[1].appendChild(badgeImage);
            setBadgeImageAdded(true);
        }
    };
    const iterateAttributes = () => {
        productSpecificationResult?.forEach(psr => {
            if (psr && psr.props.productName === 'Product Badge Status') {
                const badgeStatus = psr.props.cellData.props.dangerouslySetInnerHTML.__html;
                if (canUseDOM() && !badgeImageAdded && badgeStatus !== 'None') {
                    renderProductBadge(badgeStatus);
                }
            }
            if (psr && !attributesToIgnore.includes(psr.props.productName)) {
                elementsArray.push(psr);
            }
        });
        if (!badgeImageAdded) {
            const data = props.data as IProductSpecificationData;
            if (data.product) {
                if (data.product.Price !== data.product.BasePrice) {
                    renderProductBadge('on_sale');
                }
            }
        }
        setAttributeElementsToRender(elementsArray);
    };
    return (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>
                    {attributeElementsToRender && attributeElementsToRender.map((row) => {
                        return row;
                    })}
                </Node>
            </Node>
        </Module>
    );
};

export default ProductSpecificationView;
